<template>
    <div class="offer-box full-width" style="border-radius:2rem">
        <figure style="background-image:url('images/double_card.png');"></figure>
        <div class="copy">
            <h1 class="font-circular_bold font-llg">let's <span class="bg-ulta-pink text-white">double</span> the love</h1>
            <p class="pt-4"><strong class="text-pink font-xlmd">2X Points</strong></p>
            <p class="fs-3">2 points per $1 spent with your card at Ulta Beauty<sup>2</sup></p>
            <div class="fs-3">See additional important messages for <a class="text-decoration-none" href="https://www.ulta.com/creditcards/landingpage.jsp" target="_blank">details</a>.</div>
            <img  style="background-image:url('images/double_card.png')">
        </div>
    </div>
</template>

<script>
    export default {
        name: "PromotionComponent",
    }
</script>
